module.exports = __webpack_public_path__ + "static/media/Dubai.c4d51f27.png";